<template>
  <div class="container">
      <img v-lazy="$store.getters.getUrl('yb_logo')" :style="{'width':$store.getters.getKey('width')&&$store.getters.getKey('width'),'height':$store.getters.getKey('height')&&$store.getters.getKey('height')}" alt="">
  </div>
</template>


<script>
export default {
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  img{
      width: 270px;
  }
}
</style>